// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1mO4I","Label":"BuildControl_Label__2mHmw","Less":"BuildControl_Less__2-Xi3","More":"BuildControl_More__1JTue"};